module.exports = __webpack_public_path__ + "static/img/guide-33.fd3f9eab.png";